

import React from 'react';
import { Tabs } from 'antd';
import './TabComponent.css';
import { UserOutlined } from '@ant-design/icons';

const CustomTab = ({ entries , onChange, activeKey,
    defaultActiveKey = "1"}) => {
    const items = [
        {
            key: '1',
            label: 'Tab 1111  111111',
            children: <UserOutlined style={{ fontSize: 334 }} />,
        },
        {
            key: '2',
            label: 'Tab 2',
            children: 'Content of Tab Pane 2',
        },
        {
            key: '3',
            label: 'Tab 3',
            children: 'Content of Tab Pane 3',
        },
    ];
    return (
        <div className='tab_container'>
            <Tabs defaultActiveKey={defaultActiveKey} activeKey={activeKey} items={entries || items} onChange={onChange} className='customTab'  />
        </div>
    );
}
export default CustomTab;